// extracted by mini-css-extract-plugin
module.exports = {"main":"privacy-policy_main__8Cg9R","info":"privacy-policy_info__1HwOK"};